module.exports = __webpack_public_path__ + "static/media/S36_black.c4b81d75.png";